<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getPaymentsHeaders ()"
    :items="getItems ()"
    :loading="loadingPayments"
    :items-per-page="rowsPerPage"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.Capital | amount }}</td>
      <td class="text-xs-left">{{ props.item.FeeAmount | amount }}</td>
      <td class="text-xs-left">{{ props.item.PenaltyInterestAmount | amount }}</td>
      <td class="text-xs-left">{{ props.item.Date | date }}</td>
      <td class="text-xs-left">{{ props.item.DebtorRegistryId | kennitala }}</td>
      <td class="text-xs-right">{{ props.item.Created | date }}</td>
      <td class="text-xs-right">{{ props.item.PaymentSource }}</td>
      <td
        v-if="props.item.Source === 2 || props.item.Source === 3 || props.item.Source === 6"
        class="text-xs-right"><router-link
          :to="{name: getLink(props.item.Source),params:{id:props.item.Matching}}"
          target="_self">{{ props.item.Matching }}</router-link></td>
      <td
        v-if="!(props.item.Source === 2 || props.item.Source === 3 || props.item.Source === 6)"
        class="text-xs-right">{{ props.item.Matching }}</td>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../controllers/DataGridSort'
import EnumIterator from '../helper/EnumIterator';
    export default {
        name: "FactoringDetalPaymentsDatagrid",
        components: {DataGridSort},
      // eslint-disable-next-line vue/require-prop-types
        props: ['loadingPayments','payments','rowsPerPage'],
        data () {
          return {
            pagination:
                    {
                      sortBy: 'id'
                    }
          }
        },
        methods: {
            getPaymentsHeaders ()
            {
                return [
                    {sortable: true, text: this.$t('krita.amount'), value: 'amount', align: 'left'},
                    {sortable: true, text: this.$t('krita.factoring.feeamount'), value: 'feeAmount', align: 'left'},
                    {sortable: true, text: this.$t('krita.factoring.penaltyinterestamount'), value: 'PenaltyAmount', align: 'left'},
                    {sortable: true, text: this.$t('krita.factoring.date'), value: 'date', align: 'left'},
                    {sortable: true, text: this.$t('krita.factoring.payorregistryid'), value: 'DebtorRegistryId',align: 'left'},
                    {sortable: true, text: this.$t('krita.factoring.created'), value: 'created', align: 'right'},
                    {sortable: false, text: this.$t('krita.factoring.source'), value: 'source', align: 'right'},
                    {sortable: false, text: this.$t('krita.factoring.matching'), value: 'matching', align: 'right'}
                ]
            },
            getItems ()
            {
              let self = this;

              let items = [];
              for (let payment of self.payments)
              {
                let paymentClient = {
                  Capital: payment.Capital,
                  Created: payment.Created,
                  Date: payment.Date,
                  DebtorRegistryId: payment.DebtorRegistryId,
                  FeeAmount: payment.FeeAmount,
                  Id: payment.Id,
                  IsProcessing: payment.IsProcessing,
                  PaymentSource: self.$t(EnumIterator.processPaymentSource(payment.PaymentSource)),
                  Source: payment.PaymentSource,
                  PenaltyInterestAmount: payment.PenaltyInterestAmount,
                  RefactoringId: payment.RefactoringId,
                  RepaymentId: payment.RepaymentId,
                  SettlingId: payment.SettlingId,
                  TransactionId: payment.TransactionId,
                  Matching: self.processPaymentsMatching(payment)
                };
                items.push(paymentClient);
              }
              return items;
            },
            getLink (source)
            {
              console.log('yo')
              switch (source){
                case 0:
                break;
                case 1:
                break;
                case 2:
                console.log('hey')
                return 'Application detail';
                case 3:
                console.log('yo')
                return 'Factoring detail'
                case 4:
                break;
                case 5:
                break;
                case 6:
                console.log('ha yooo')
                return 'Repayment detail'
              }
            },
            processPaymentsMatching (obj)
            {
              let self = this;

              if (obj.TransactionId !== null | obj.SettlingId !== null | obj.RefactoringId !== null | obj.RepaymentId !== null)
              {
                // if (obj.TransactionId !== null){
                //   return obj.TransactionId;
                // }
                if (obj.SettlingId !== null){
                  return obj.SettlingId;
                }
                else if (obj.RefactoringId !== null){
                  return obj.RefactoringId;
                }
                else if (obj.RepaymentId !== null){
                  return obj.RepaymentId;
                }
                else{
                  return self.$t('krita.common.true');
                }
              }
              else
              {
                return self.$t('krita.common.false');
              }
            },
          changeSort (sort)
          {
              let self = this;

              self.pagination.sortBy = sort.sortBy;
              self.pagination.descending = sort.descending;
              self.$emit('refreshWithSort',self.pagination);
          }
        }
    }
</script>

<style scoped>

</style>
